<mat-dialog-actions>
  <div class="actions-buttons">
    <app-x-icon-button title="Annuler les modifications" (click)="onCancel()"></app-x-icon-button>
    @if (canDraftMode) {
      <mat-button-toggle-group
        name="editMode"
        aria-label="Mode d'édition"
        class="edit-mode-toggle"
        [value]="validationMode"
        (change)="onValidationModeChange($event.value)"
        matTooltip="Règles de validation à utiliser pour préparer le contrat à la validation"
      >
        <mat-button-toggle [value]="false">Brouillon</mat-button-toggle>
        <mat-button-toggle [value]="true">Validation</mat-button-toggle>
      </mat-button-toggle-group>
    } @else if (contractListItem(); as listItem) {
      <div class="space-between">
        <div class="contract-state">
          <app-contract-status [status]="listItem.status"></app-contract-status>
          <app-signature-send-failure [contract]="listItem"></app-signature-send-failure>
        </div>
        <div class="contract-actions">
          <app-button-contract-history [contract]="listItem"></app-button-contract-history>
          @if (refreshedContract() ?? inputData(); as contract) {
            <app-button-establish-amendment [contract]="contract"></app-button-establish-amendment>
          }
          <app-button-contract-pdf
            [contract]="listItem"
            (documentReady)="openDocument($event)"
          ></app-button-contract-pdf>
          <app-contract-action-buttons
            [contract]="listItem"
            (contractUpdated)="onContractUpdated($event)"
            (signatureRequested)="refreshContract()"
            (signatureRequestFailed)="refreshContract()"
            (contractDeleted)="onContractDeleted()"
          ></app-contract-action-buttons>
        </div>
      </div>
    }
  </div>
  <div>
    @if (inputData()?.id) {
      <app-copy-location-button></app-copy-location-button>
    }
    <app-save-button
      (click)="onSave()"
      [isEditMode]="inputData()?.id ? true : false"
      [enabled]="allTabsFormsValid"
    ></app-save-button>
  </div>
</mat-dialog-actions>

<mat-dialog-content>
  @if (contactSig && contractSig && schedulesSig && showPreview) {
    <app-embauche-view
      [contact]="contactSig()"
      [contract]="contractSig()"
      [schedules]="schedulesSig()"
      [assignment]="assignmentSig()"
      [documents]="documentsSig()"
      (openDocument)="openDocument($event)"
    ></app-embauche-view>
  }
  <app-embauche-tabs-form
    [initWith]="inputData()"
    [validation]="validationMode"
    [readOnly]="isReadOnly"
    (documentUploaded)="onDocumentUploaded($event)"
    (documentsMetadataChanged)="onDocumentsMetadataChanged($event)"
    class="w-100"
  ></app-embauche-tabs-form>
</mat-dialog-content>
